import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "@/client/hooks/use-toast";

const ReCaptchaComponent = ({
    recaptchaRef,
    onError,
}: {
    recaptchaRef: React.RefObject<ReCAPTCHA>;
    onError?: () => void;
}) => {
    const getTheme = () => {
        const theme = localStorage.getItem("theme");
        if (theme === "dark") {
            return "dark";
        }
        return "dark";
    };
    return (
        <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.NEXT_PUBLIC_RE_CAPTCHA_SITE_KEY!}
            size="invisible"
            badge="bottomright"
            className="invisible"
            onError={(e) => {
                toast({
                    variant: "destructive",
                    title: "ReCAPTCHA Error",
                    description: "Please refresh the page and try again",
                });

                if (onError) {
                    onError();
                }
            }}
        />
    );
};

export default ReCaptchaComponent;
